import React, { useState } from 'react'
import useArDocument from '../../hooks/useArDocument'
import useUser from '../../hooks/useUser';
import WriteLog from '../Globals/WriteLog';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';


import {
    faFilePdf,
    faImage,
    faFileWord,
    faFileExcel,
    faFileCsv,
    faFileText,
    faEye,
    faDownload,
    faSearch
    

} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DownloadCustLocDoc, PreviewCustLocDoc } from '../Globals/Functions';
import { LinearProgress } from '@mui/material';
import useLocation from '../../hooks/useLocation';

const names = [
    "bmp",
    "csv",
    "doc",
    "docx",
    "jpg",
    "pdf",
    "png",        
    "txt",
    "xls",
    "xlsx",
  ];


const ITEM_HEIGHT = 35;
const ITEM_PADDING_TOP = 1;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      transform: "scale(0.8)"
    },
  },
};


function Document({addrSeq}) {

    const { user } = useUser();
    WriteLog("Document->user", user)
    const documents = useArDocument(user?.customer_code, addrSeq, user?.token)
    WriteLog("Document->documents", documents)

    WriteLog("Document->addrSeq", addrSeq)

    //location
    const { locations } = useLocation(user?.customer_code, user?.token);                
    WriteLog("Document->locations", locations);      
    var location = locations?.locations?.filter(l=> l.AddrSeq == addrSeq);
    if(location?.length>0) location = location[0];
    WriteLog("Document->location", location);
    
    const [docName, setDocName] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState();

    const handleChange = (event) => {
        const {
          target: { value },
        } = event;
        setDocName(
          // On autofill we get a stringified value.
          typeof value === 'string' ? value.split(',') : value,
        );
      };



    const handleSearchKeyword = (e)=>{
        
        const keyword = e.target.value
        setSearchKeyword(keyword)        
        // WriteLog("Document->e.target.value", e.target.value)
        
    }

    const filteredDocs = FilterDoc()        
    function FilterDoc()
    {
        var docs = []
        WriteLog("Document->searchKeyword", searchKeyword)
        
        //first filter with the doc type
        if(docName?.length>0)
        {
            docName.map((t)=>(            
                documents.documents.filter((d)=>d.doc_type === t).map((b)=>(
                    docs.push(b)
                ))                        
            ))                    
        }
        else
            docs = documents.documents
        
        //now filter with lkeywords
        if(searchKeyword?.length>0) 
        {
            WriteLog("Document->searchKeyword", searchKeyword)
            return docs.filter((d)=>d.description.includes(searchKeyword)) 
        }         
        else
            return docs;
    }

    const [previewDownload, setPreviewDownload] = useState(false);
    
    const handlePreviewDoc = (e, docName, docSeq, docType)=>{
        PreviewCustLocDoc(e, docSeq, setPreviewDownload, user?.token, docType, docName)        
    }

    const handleDownloadDoc = (e, docName, docSeq, docType)=>{        
        DownloadCustLocDoc(e, docSeq, setPreviewDownload, user?.token, docType, docName)                
    }

    

    return (
        <div className="flex-grow bg-white p-5 ">  
            
            <div className='text-3xl font-bold'>Documents:</div>
            <div className='flex justify-between items-center mb-2'>                
                <div className='flex items-center hover:bg-slate-200 rounded-lg'>
                    <div className='ml-2'>Type:</div>
                    <div className= ''>
                        <FormControl sx={{ m: 0, width: 150, p:0, height:55}}>                            
                            <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            value={docName}
                            onChange={handleChange}                    
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                            autoWidth={false}                            
                            >
                            {names.map((name) => (
                                <MenuItem key={name} value={name}>
                                {name === "bmp" &&
                                    <FontAwesomeIcon icon={faImage} className="w-5 h-5 text-cyan-500"/>
                                }
                                {name === "csv" &&
                                    <FontAwesomeIcon icon={faFileCsv} className="w-5 h-5 text-red-500"/>
                                }                        
                                {name === "doc" &&
                                    <FontAwesomeIcon icon={faFileWord} className="w-5 h-5 text-blue-500"/>
                                }                        
                                {name === "docx" &&
                                    <FontAwesomeIcon icon={faFileWord} className="w-5 h-5 text-blue-500"/>
                                }                        
                                {name === "jpg" &&
                                    <FontAwesomeIcon icon={faImage} className="w-5 h-5 text-cyan-500"/>
                                }                        
                                {name === "pdf" &&
                                    <FontAwesomeIcon icon={faFilePdf} className="w-5 h-5 text-red-500"/>
                                }                        
                                {name === "png" &&
                                    <FontAwesomeIcon icon={faImage} className="w-5 h-5 text-cyan-500"/>
                                }                        
                                {name === "txt" &&
                                    <FontAwesomeIcon icon={faFileText} className="w-5 h-5 text-gray-500"/>
                                }                        
                                {name === "xls" &&
                                    <FontAwesomeIcon icon={faFileExcel} className="w-5 h-5 text-green-500"/>
                                }                        
                                {name === "xlsx" &&
                                    <FontAwesomeIcon icon={faFileExcel} className="w-5 h- text-green-500"/>
                                }                        
                                <Checkbox checked={docName.indexOf(name) > -1} />
                                <ListItemText primary={name} />
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>                  
                <div className='flex ml-2 item-center rounded-full bg-gray-100 p-2'>
                    <FontAwesomeIcon icon={faSearch} className='h-6 text-slate-400'/>
                    <input className='hidden md:inline-flex ml-2 items-center bg-transparent 
                    outline-none placeholder-gray-500 flex-shrink' type='text' 
                    placeholder='Search in docs' onKeyUp={(e)=>handleSearchKeyword(e)}></input>
                </div>
            </div>   
            <div className='flex  mt-2 items-baseline space-x-2'>
                <div className='text-xl text-gray-500 font-bold'>Location:</div>
                <div className='text-sm'>{addrSeq>=0?location?.Name:"All"}</div>
            </div>    
            <div className='mb-1'>
                    {(!filteredDocs || previewDownload) &&
                        <LinearProgress color='primary' />
                    }
                </div>                                     
            <div className='p-2 bg-slate-200 rounded-lg'>
                {filteredDocs?.map((d) => (     
                    <div key ={d.id} className='flex justify-between bg-white rounded-lg m-1'>
                        <div className='flex items-center space-x-3 p-2'>
                            {d.doc_type === "pdf" &&
                                <div>                                    
                                    <FontAwesomeIcon icon={faFilePdf} className="w-5 h-5 text-red-500"/>                                    
                                </div>
                            }                                                
                            {(d.doc_type === "ico" || d.doc_type === "jpg") &&
                                <div>
                                    <FontAwesomeIcon icon={faImage} className="w-5 h-5 text-cyan-500"/>
                                </div>
                            }                                                
                            {(d.doc_type === "doc" ||  d.doc_type === "docx") &&
                                <div>
                                    <FontAwesomeIcon icon={faFileWord} className="w-5 h-5 text-blue-500"/>
                                </div>
                            }
                            {(d.doc_type === "xls" ||  d.doc_type === "xlsx") &&
                                <div>
                                    <FontAwesomeIcon icon={faFileExcel} className="w-5 h-5 text-green-400"/>
                                </div>
                            }

                            {d.doc_type === "csv" &&
                                <div>
                                    <FontAwesomeIcon icon={faFileCsv} className="w-5 h-5 text-violet-400"/>
                                </div>
                            }
                            {d.doc_type === "txt" &&
                                <div>
                                    <FontAwesomeIcon icon={faFileText} className="w-5 h-5 text-gray-400"/>
                                </div>
                            }
                        
                            <div className='text-[13px]'>{d.description}</div>
                        </div>
                        <div className='flex space-x-4 items-center m-2'>
                            <div className='text-[12px]'>{d.size}</div>
                            <div className='flex cursor-pointer rounded-full bg-gray-200 p-1 hover:bg-slate-300' onClick={(e)=>handlePreviewDoc(e, d.name, d.doc_seq, d.doc_type)} >
                                <FontAwesomeIcon icon={faEye} className="w-5 h-5 text-teal-600"/>                        
                            </div>
                            <div className='flex cursor-pointer rounded-full bg-gray-200 p-1 hover:bg-slate-300' onClick={(e)=>handleDownloadDoc(e, d.name, d.doc_seq, d.doc_type)} >
                                <FontAwesomeIcon icon={faDownload} className="w-5 h-5 text-lime-600"/>                        
                            </div>
                        </div>                        
                    </div>
                ))} 
            </div>            
        </div>
    )
}

export default Document